export const RINV_STATUS_STYLES: Record<string, { pill: string; dot: string }> = {
  ACTIVE: { pill: 'bg-emerald-50 text-emerald-800', dot: 'bg-emerald-500' },
  PAUSED: { pill: 'bg-amber-50 text-amber-800', dot: 'bg-amber-500' },
  CANCELLED: { pill: 'bg-rose-50 text-rose-800', dot: 'bg-rose-500' },
  FINISHED: { pill: 'bg-stone-100 text-stone-400', dot: 'bg-stone-300' },
}

export const RINV_STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Active',
  PAUSED: 'Paused',
  CANCELLED: 'Cancelled',
  FINISHED: 'Finished',
}
